import React from 'react';
import { OcorrenciaTipo, OcorrenciaStatus, LABEL_OCORRENCIA } from '../shared/atlasApi';

const CLASSES_TIPO: Record<OcorrenciaTipo, string> = {
  orientacao: 'bg-blue-100 text-blue-700',
  advertencia_verbal: 'bg-amber-100 text-amber-700',
  advertencia_escrita: 'bg-orange-100 text-orange-700',
  suspensao: 'bg-rose-100 text-rose-700',
  elogio: 'bg-emerald-100 text-emerald-700',
};

const LABEL_STATUS: Record<OcorrenciaStatus, string> = {
  registrada: 'Registrada',
  ciente: 'Ciente',
  contestada: 'Contestada',
  anulada: 'Anulada',
};

const CLASSES_STATUS: Record<OcorrenciaStatus, string> = {
  registrada: 'bg-gray-100 text-gray-600',
  ciente: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  contestada: 'bg-amber-50 text-amber-700 border border-amber-200',
  anulada: 'bg-gray-100 text-gray-400 line-through',
};

export const BadgeTipo: React.FC<{ tipo: OcorrenciaTipo }> = ({ tipo }) => (
  <span className={`px-2 py-0.5 rounded-full text-[11px] font-semibold ${CLASSES_TIPO[tipo] || 'bg-gray-100 text-gray-600'}`}>
    {LABEL_OCORRENCIA[tipo] || tipo}
  </span>
);

export const BadgeStatusOcorrencia: React.FC<{ status: OcorrenciaStatus }> = ({ status }) => (
  <span className={`px-2 py-0.5 rounded-full text-[11px] font-medium ${CLASSES_STATUS[status] || 'bg-gray-100 text-gray-600'}`}>
    {LABEL_STATUS[status] || status}
  </span>
);

export default BadgeTipo;
